<template>
  <table class="members-table">
    <Loader v-if="loading" />
    <thead class="members-table__header">
      <tr class="members-table__header-row">
        <th
          class="members-table__header-data"
          ref="tableHead"
          :style="gridStyling"
        >
          <div
            class="members-table__header-cell"
            :class="[header === 'id' ? 'tw-hidden' : null]"
            v-for="(header, index) in tableHeaders"
            :key="'header' + index"
          >
            {{ header }}
          </div>
        </th>
      </tr>
    </thead>
    <tbody class="members-table__body">
      <tr class="members-table__body-row">
        <td class="members-table__body-data" ref="tableRow">
          <div
            class="members-table__row"
            :ref="rowDetails"
            v-for="(details, index) in tableRows"
            :key="'row' + index"
            :style="gridStyling"
          >
            <div
              class="members-table__cell"
              :class="[detail.includes('data-id') ? 'tw-hidden' : null]"
              v-for="(detail, i) in details"
              :key="detail.id"
            >
              <p
                v-html="detail"
                class="members-table__cell-text"
                :class="[i === 'status' ? detail.toLowerCase(0) : null]"
              ></p>
            </div>
            <div class="members-table__actions">

              <Popper offsetDistance="5">
          <button
            class="action-trigger"
            :disabled="!isActionAllowed"
          >
          <img
                  src="https://res.cloudinary.com/djalafcj9/image/upload/v1635311248/getequityV2/options-horizontal_ps9ovq.webp"
                  alt="share"
                  loading="lazy"
                />
          </button>
          <template #content>
            <div class="action-dropdown">
              <ul class="action-dropdown__list">
                    <li
                      v-if="details.status === 'Active'"
                      class="action-dropdown__item"
                      @click="openAddBankDetailsForm(details)"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/bank-info.svg"
                        alt="send deal"
                      />
                      Add bank details
                    </li>
                    <li
                      v-if="details.status === 'Deactivated'"
                      class="action-dropdown__item"
                      @click="setCurrentMember(details.id, 'activate')"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/success-circle.svg"
                        alt="activate"
                      />
                      Activate member
                    </li>
                    <li
                      v-if="details.status === 'Active' && deals.length !== 0"
                      class="action-dropdown__item"
                      @click="openSendDealModal(details)"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/member-profile.svg"
                        alt="send deal"
                      />
                      Send deal
                    </li>

                    <li
                      v-if="details.status === 'Active'"
                      class="action-dropdown__item"
                      @click="setCurrentMember(details.id, 'deactivate')"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/close-circle.svg"
                        alt="decline"
                      />
                      Deactivate member
                    </li>
                    <li
                      v-if="details.status === 'Active'"
                      class="action-dropdown__item action-dropdown__item--danger"
                      @click="setCurrentMember(details.id, 'remove')"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/delete.svg"
                        alt="decline"
                      />
                      Remove member
                    </li>
                    <li
                      v-if="details.status === 'Pending'"
                      class="action-dropdown__item"
                      @click="setCurrentMember(details.id, 'accept')"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/success-circle.svg"
                        alt="accept"
                      />
                      Accept
                    </li>
                    <li
                      v-if="details.status === 'Pending'"
                      class="action-dropdown__item action-dropdown__item--danger"
                      @click="setCurrentMember(details.id, 'decline')"
                    >
                      <img
                        class="action-dropdown__icon"
                        src="@/assets/img/close-circle.svg"
                        alt="decline"
                      />
                      Decline
                    </li>
                  </ul>
            </div>
          </template>
        </Popper>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot class="members-table__footer">
      <Pagination
        class="members-table__pagination"
        :totalPage="totalPage"
        :currentPage="currentPage"
        :maxVisible="9"
        @pageChange="gotoPage"
      />
    </tfoot>
    <AddBankDetails
      v-if="showAddBankDetailsForm"
      :member="member"
      @close-modal="showAddBankDetailsForm = false"
    />
    <SendDeal
      v-if="showTransferTokenModal"
      :show="showTransferTokenModal"
      :member="member"
      :deals="deals"
      @close-send-deal="showTransferTokenModal = false"
    />
    <ActivateModal
      v-if="showActivateModal"
      class="tw-z-20"
      @close="showActivateModal = !showActivateModal"
      :member="currentMember"
      @update-members="$emit('update-members')"
      @close-activate-modal="showActivateModal = false"
    />
    <DeactivateModal
      v-if="showDeActivateModal"
      :member="currentMember"
      @update-members="$emit('update-members')"
      @close-deactivate-modal="showDeActivateModal = false"
    />
    <RemoveModal
      v-if="showRemoveModal"
      :member="currentMember"
      @update-members="$emit('update-members')"
      @close-remove-modal="showRemoveModal = false"
    />
    <AcceptModal
      v-if="showAcceptModal"
      :member="currentMember"
      @update-members="$emit('update-members')"
      @close-accept-modal="showAcceptModal = false"
    />
    <DeclineModal
      v-if="showDeclineModal"
      :member="currentMember"
      @update-members="$emit('update-members')"
      @close-decline-modal="showDeclineModal = false"
    />
  </table>
</template>

<script>
  import { mapActions } from "vuex";
  import DeactivateModal from "@/components/members/DeactivateModal";
  import AddBankDetails from "@/components/members/AddBankDetails";
  import ActivateModal from "@/components/members/ActivateModal";
  import RemoveModal from "@/components/members/RemoveModal.vue";
  import AcceptModal from "@/components/members/AcceptModal";
  import DeclineModal from "@/components/members/DeclineModal";
  import TransferTokenModal from "@/components/general/MediumModal";
  import Pagination from "@/components/navigation/Pagination";
  import SendDeal from "@/components/members/SendDeal";
  import Popper from "vue3-popper";


  export default {
    name: "MembersTable",

    components: {
      Pagination,
      DeactivateModal,
      ActivateModal,
      AcceptModal,
      DeclineModal,
      AddBankDetails,
      TransferTokenModal,
      RemoveModal,
      SendDeal,
      Popper
    },

    props: {
      tableHeaders: { type: Array, default: () => [], required: true },
      tableRows: { type: Array, default: () => [], required: true },
      columnNumber: { type: Number, default: () => 0, required: true },
      columnWidth: { type: Number, default: () => 0, required: true },
      totalPage: { type: Number, default: () => 0, required: true },
      currentPage: { type: Number, default: () => 0, required: true },
      deals: { type: Array, default: () => [], required: true },
      isActionAllowed: Boolean,
    },

    emits: ["gotoPage", "update-members"],

    data() {
      return {
        rows: [],
        type: "",
        columnSize: "",
        id: "",
        member: {},
        currentMember: null,
        loading: false,
        dealsLoading: false,
        showActivateModal: false,
        showDeActivateModal: false,
        showRemoveModal: false,
        showAcceptModal: false,
        showDeclineModal: false,
        showTransferTokenModal: false,
        showAddBankDetailsForm: false,
        statuses: [""],
      };
    },
    computed: {
      gridStyling() {
        return {
          "grid-template-columns": `180px minmax(220px, 1fr) 180px 120px 80px repeat(${
            this.columnNumber
          }, ${0}px)`,
        };
      },
    },

    methods: {
      ...mapActions("organisationModule", ["pendingInvite"]),

      rowDetails(el) {
        this.rows.push(el);
      },

      async openSendDealModal(member) {
        this.showTransferTokenModal = true;
        this.dealsLoading = true;
        this.member = member;
        return;
      },
      async openAddBankDetailsForm(member) {
        this.showAddBankDetailsForm = true;
        this.member = member;
        return;
      },
      setCurrentMember(memberId, modalType) {
        this.currentMember = memberId.split("/")[1];
        switch (modalType) {
          case "deactivate":
            this.showDeActivateModal = true;
            break;
          case "activate":
            this.showActivateModal = true;
            break;
          case "decline":
            this.showDeclineModal = true;
            break;
          case "accept":
            this.showAcceptModal = true;
            break;
          case "remove":
            this.showRemoveModal = true;
            break;
        }
      },

      async acceptMember(event, memberId) {
        if (event.target.innerText === "Accept") {
          this.id = memberId.split("/")[1];
          this.showAcceptModal = true;
          return;
        }
        this.acceptLoading = true;
        const payload = { id: this.id, action: "accept" };
        const response = await this.pendingInvite(payload);
        if (response) {
          this.$emit("update-members");
        }
        this.acceptLoading = false;
      },

      setTableColumn() {
        this.columnSize = `repeat(${this.columnNumber}, ${
          this.columnWidth
        }px) ${120}px`;
        this.setColumnStatus();

        this.$refs.tableHead.style.gridTemplateColumns = this.columnSize;
        this.rows.forEach((row) => {
          row.style.gridTemplateColumns = this.columnSize;
        });
      },

      setColumnStatus() {
        this.rows.forEach((row) => {
          let columns = row?.querySelectorAll("p");
          if (columns[columns.length - 1].innerHTML === "Active") {
            columns[columns.length - 1].classList.add("active");
          } else if (columns[columns.length - 1].innerHTML === "Deactivated") {
            columns[columns.length - 1].classList.add("deactivated");
          } else {
            columns[columns.length - 1].classList.add("pending");
          }
        });
      },

      gotoPage(page) {
        this.$emit("gotoPage", page);
      },
    },
  };
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F8FAFC;
$bg-hover: #F1F5F9;
$border-color: #E2E8F0;
$success: #059669;
$success-light: #ECFDF5;
$warning: #D97706;
$warning-light: #FEF3C7;
$error: #DC2626;
$error-light: #FEF2F2;

.members-table {
  @include fadeIn;
  width: 100%;
  margin-bottom: 32px;
  position: relative;
  border-collapse: collapse;

  &__header-data {
    display: grid;
    column-gap: 16px;
    background: $bg-subtle;
    padding: 16px 0;
    border-radius: 8px 8px 0 0;
  }

  &__header-cell {
    justify-self: start;
    padding-left: 24px;
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: $text-muted;
  }

  &__row {
    display: grid;
    column-gap: 16px;
    padding: 20px 0;
    border-top: 1px solid $border-color;
    transition: background 0.15s ease;

    &:hover {
      background: $bg-hover;
    }

    &:first-child {
      border-top: none;
    }
  }

  &__cell {
    align-self: center;
    padding-left: 24px;
    min-width: 0;
  }

  &__cell-text {
    font-size: 14px;
    color: $text-secondary;
    line-height: 1.5;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  &__actions {
    position: relative;
    display: flex;
    justify-content: center;
  }

  // Status badges
  &__body-data {
    .active,
    .pending,
    .deactivated {
      display: inline-flex;
      align-items: center;
      text-align: center;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.02em;
    }

    .active {
      color: $success;
      background-color: $success-light;
    }

    .pending {
      color: $warning;
      background-color: $warning-light;
    }

    .deactivated {
      color: $error;
      background-color: $error-light;
    }
  }

  .loading {
    @media screen and (min-width: 1280px) {
      margin-right: 20%;
    }
  }

  // Action trigger button
  .action-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: $bg-subtle;
      border-color: $border-color;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    img {
      width: 18px;
      height: 18px;
      opacity: 0.7;
    }
  }

  // Action dropdown menu
  .action-dropdown {
    min-width: 220px;
    padding: 8px;
    background: #FFFFFF;
    border-radius: 12px;
    border: 1px solid $border-color;

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__item {
      display: flex;
      align-items: center;
      padding: 12px 14px;
      font-size: 14px;
      font-weight: 450;
      color: $text-secondary;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background: $bg-subtle;
        color: $text-primary;
      }

      &--danger {
        color: $error;

        &:hover {
          background: $error-light;
          color: $error;
        }
      }
    }

    &__icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      flex-shrink: 0;
      opacity: 0.8;
    }
  }

  // Table footer & pagination
  &__footer {
    display: block;
  }

  &__pagination {
    margin-left: 24px;
    margin-top: 24px;
  }
}
</style>
